export enum StoreType {
    UNITY='UNITY',
    DESTINATION='DESTINATION'
}